module.exports = __webpack_public_path__ + "static/media/esim_graph2_en.b33a4a55.png";